import { getConceptAmountsPayload } from '@/returns/helpers/helpers'

export const transformRequestIssueRefund = ({ returnId, refundMethod, note, concepts }) => {
  return {
    returnId,
    payload: {
      refund_method: refundMethod,
      note,
      ...getConceptAmountsPayload(concepts),
    },
  }
}
